// 常用参数
const params = {
  VUE_APP_API_BASE: process.env.NODE_ENV == 'development' ? 'https://app.yimoubi.com' : 'https://app.yimoubi.com',  // 域名接口
}
export default params;



// WEBPACK FOOTER //
// ./src/config/config.js